import type { StoredStage } from "./stageRecord.js";

export type HubItem = {
  id: string;
  name: string;
  status: "draft" | "published";
};

export function hubItems(stored: Record<string, StoredStage>): { drafts: HubItem[]; published: HubItem[] } {
  const rows = Object.values(stored).map((stage) => ({
    id: stage.id,
    name: stage.name,
    status: stage.status,
  }));
  return {
    drafts: rows.filter((row) => row.status === "draft"),
    published: rows.filter((row) => row.status === "published"),
  };
}
